var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('e-dialog',{attrs:{"dialog-title":"提示","center-dialog-visible":_vm.sameIpTip,"popup-width":"400px","closeBtn":true},on:{"resetPopupData":_vm.handleClose,"submitPopupData":_vm.handleClose}},[_vm._v(" 尊敬的用户，您好！在操作订单时，系统检测到您与采购商的IP地址相同。 根据平台规定，供应商与采购商需使用不同的IP地址进行操作，以确保交易安全和数据的准确性。 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }